// Human-readable labels for planning period keys.
//
// The planning system stores two key shapes (see app/lib/period_keys.rb):
//   • calendar quarter keys — "YYYY-QN"  (e.g. "2026-Q2")
//   • member cycle keys      — "YYYY-cN"  (e.g. "2026-c2", "c" = cycle)
// The raw cycle key was leaking into the UI (e.g. the dashboard greeting read
// "2026-c2"). These formatters turn the stored key into something a member
// understands. Unknown shapes fall back to the raw string.

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
]

// "2026-c2" → "Cycle 2 · 2026" (or "Cycle 2" with { year: false })
// "2026-Q2" → "Q2 · 2026"     (or "Q2" with { year: false })
export function formatPeriodKey(key, { year = true } = {}) {
  if (!key) return ""

  const cycle = /^(\d{4})-c(\d+)$/.exec(key)
  if (cycle) {
    const [, y, n] = cycle
    return year ? `Cycle ${n} · ${y}` : `Cycle ${n}`
  }

  const quarter = /^(\d{4})-Q([1-4])$/.exec(key)
  if (quarter) {
    const [, y, q] = quarter
    return year ? `Q${q} · ${y}` : `Q${q}`
  }

  return key
}

// "2026-07" → "July 2026"
export function formatMonthKey(key) {
  if (!key) return ""
  const m = /^(\d{4})-(\d{2})$/.exec(key)
  if (!m) return key
  const idx = parseInt(m[2], 10) - 1
  return MONTHS[idx] ? `${MONTHS[idx]} ${m[1]}` : key
}

// "2026-07" → "Jul" — compact label for the KPI/KOI month strip.
export function formatMonthShort(key) {
  if (!key) return ""
  const m = /^(\d{4})-(\d{2})$/.exec(key)
  if (!m) return key
  const idx = parseInt(m[2], 10) - 1
  return MONTHS[idx] ? MONTHS[idx].slice(0, 3) : key
}
